import axios from "axios";

const BASE_URL = "https://vas.worlinks.com/api/gamerClub/lebara-ksa-d";

const KsaService = {
  init: async (lang) => {
    const res = await axios.get(`${BASE_URL}/init?lang=${lang}`);
    return res.data;
  },

  verify: async (payload) => {
    const res = await axios.post(`${BASE_URL}/verify`, payload);
    return res.data;
  },

  resendOtp: async (payload) => {
    const res = await axios.post(`${BASE_URL}/resendotp`, payload);
    return res.data;
  },

  appendScriptToHead: (scriptSrc) => {
    const existingScript = document.querySelector(`script[src="${scriptSrc}"]`);
    if (!existingScript) {
      const script = document.createElement("script");
      script.src = scriptSrc;
      document.head.appendChild(script);
    }
  },

  getDate: (milliseconds) => {
    const date = new Date(milliseconds);
    const yy = String(date.getFullYear()).slice(-2);
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const hh = String(date.getHours()).padStart(2, "0");
    const min = String(date.getMinutes()).padStart(2, "0");
    const sec = String(date.getSeconds());
    return `${yy}-${mm}-${dd} ${hh}:${min}:${sec}`;
  },

  isEnriched: () => {
    return window.TPay?.HeaderEnrichment?.enriched() ?? false;
  },

  checkSubscription: (productSKU) => {
    return new Promise((resolve, reject) => {
      try {
        window.TPay.HeaderEnrichment.hasSubscription(
          productSKU,
          (result, subId) => {
            resolve({ result, subId });
          }
        );
      } catch (error) {
        reject(`Error checking subscription: ${error}`);
      }
    });
  },

  initOperator: (operatorCode) => {
    window.TPay?.HeaderEnrichment?.init({ operatorCode });
  },

  getPhoneNumber: () => {
    return window.TPay?.HeaderEnrichment?.msisdn();
  },

  getOperatorCode: () => {
    return window.TPay?.HeaderEnrichment?.OperatorCode();
  },

  confirmSubscription: async (subscriptionInfo) => {
    return new Promise((resolve, reject) => {
      try {
        window.TPay.HeaderEnrichment.confirm(
          subscriptionInfo,
          (status, refCode, contract) => {
            resolve({ status, refCode, contract });
          }
        );
      } catch (error) {
        reject(`Error: ${error}`);
      }
    });
  },

  loginMulti: async (payload) => {
    const res = await axios.post(
      "https://vas.worlinks.com/api/gamerClub/lebara-ksa-d/login",
      payload
    );
    return res.data;
  },
};

export default KsaService;
